import * as React from 'react';
import {TextArea} from '@sail/ui';

export const Uncontrolled = () => (
  <TextArea
    onChange={(e) => {
      // eslint-disable-next-line no-console
      console.log(e);
    }}
    label="About your business"
    placeholder="Our business is…"
  />
);
